import firebase from "../firebase";
import GENRALHELPERS from "../GENRAL-HELPERS";
import spinner from "../spinner";
import display from "../stack-display/display";
import generateHtml from "./generate-html";
// import html2canvas from "html2canvas"; // ES6 Import
import callMakeCanvas from "../make-canvas.js";
const htmlToImage = require("html-to-image");
import bigError from "../big-error.js";

import makeIMG from "../make-to-img.js";


import { Share } from '@capacitor/share';

class ShareNow {
  #imgLocalUrlForSharing = null;
  #callGenerateImgNum = 0;
  #customImgEventActivated = false;
  #eventInitialized;
  #abortedNum = 0;
  #isFromBusiness = null;
  #data;
  #what;
  #imageFileForSharing = null;
  constructor() {
    // this._open();
    this.#eventInitialized = false;
  }

  _events() {
    if (this.#eventInitialized) return;
    const ShareWindowBackButton = document.getElementById(
      "ShareWindowBackButton"
    );
    const textarea = document.getElementById("editableTextInShareNowInput");

    textarea.addEventListener("input", function () {
      this.style.height = "auto"; // Reset height to shrink if needed
      this.style.height = this.scrollHeight + "px"; // Expand based on content
    });

    const ShareWindowButtonShareAgain = document.getElementById(
      "ShareWindowButtonShareAgain"
    );
    const ShareWindowButtonCopyLink = document.getElementById(
      "ShareWindowButtonCopyLink"
    );
    ShareWindowButtonCopyLink.addEventListener("click", () => {
      spinner._displaySpinner("Copiando texto");
      this._copyToClipboard(this._getCombinedText());
    });
    ShareWindowButtonShareAgain.addEventListener("click", () => {
      console.log("clicked here");

      this._shareImageFromContainer();
    });

    ShareWindowBackButton.addEventListener("click", () => {
      console.log("clicked here");
      this._close();
    });
    this.#eventInitialized = true;
  }

  _close() {
    const ShareWindowMainCon = document.getElementById("ShareWindowMainCon");
    ShareWindowMainCon.style.display = "none";
  }

  _open(data, what, listName = null) {
    console.log(data, what);
    this.#abortedNum = 0;
    spinner._displaySpinner("Preparando para compartir");
    this.#data = data;
    this.#what = what;
    const ShareWindowMainCon = document.getElementById("ShareWindowMainCon");
    ShareWindowMainCon.style.display = "flex";
    this._prepareImgForShare(0, listName);
    if (this.#eventInitialized) return;
    this._events();
  }

  _handleSelectCustomImgForSharing(imgsArr) {
    const insertAllImagesToSelectFrom = document.getElementById(
      "insertAllImagesToSelectFrom"
    );
    insertAllImagesToSelectFrom.innerHTML = "";

    imgsArr.forEach((img, i) => {
      let actClass = "";
      if (i < 1) {
        actClass = "shareWindowConB3Act";
      }
      let imgHtml = `<img class="shareWindowImgForCustomSelecting shareWindowConB3 ${actClass}" src="${img.res_200 ?? img}" />`;
      insertAllImagesToSelectFrom.insertAdjacentHTML("beforeend", imgHtml);
    });

    const setImageAndUrl = (i) => {
      const ShareWindowItemLinkText = document.getElementById(
        "ShareWindowItemLinkText"
      );
      const isImageInSharingCon = document.getElementById(
        "isImageInSharingCon"
      );

      const [link, img] = ShareWindowItemLinkText.textContent.split("&img=");
      isImageInSharingCon.querySelector("img").src = imgsArr[i].res_500 ?? imgsArr[i];
      ShareWindowItemLinkText.textContent = link + `&img=${i}`;
    };

    const events = () => {
      this.#customImgEventActivated = true;
      const allImgs = insertAllImagesToSelectFrom.querySelectorAll(
        ".shareWindowImgForCustomSelecting"
      );
      console.log(allImgs);
      allImgs.forEach((img) => {
        img.addEventListener("click", () => {
          allImgs.forEach((imgSorting, i) => {
            imgSorting.classList.remove("shareWindowConB3Act");
            if (imgSorting === img) {
              imgSorting.classList.add("shareWindowConB3Act");
              setImageAndUrl(i);
            }
          });
        });
      });
    };
    // if (this.#customImgEventActivated) return;
    events();
  }

  async _prepareImgForShare(useImg = 0, listName) {
    try {
      this.#isFromBusiness = true;
      const isImageInSharingCon = document.getElementById(
        "isImageInSharingCon"
      );
      const textarea = document.getElementById("editableTextInShareNowInput");
      const ShareWindowItemLinkText = document.getElementById(
        "ShareWindowItemLinkText"
      );
      const ShareWindowInLinkTitle = document.getElementById(
        "ShareWindowInLinkTitle"
      );
      const ShareWindowInLinkDescription = document.getElementById(
        "ShareWindowInLinkDescription"
      );
      const ShareWindowItemInstructionsText = document.getElementById(
        "ShareWindowItemInstructionsText"
      );
      const ShareWindowInsertShareImgCon = document.getElementById(
        "ShareWindowInsertShareImgCon"
      );
      const insertAllImagesToSelectFromMainContainer = document.getElementById(
        "insertAllImagesToSelectFromMainContainer"
      );
      if (isImageInSharingCon) {
        isImageInSharingCon.remove();
      }
      if (this.#what === "listing") {
        insertAllImagesToSelectFromMainContainer.style.display = "flex";
        ShareWindowItemLinkText.textContent = this.#data.listingUrl;
        ShareWindowItemInstructionsText.textContent =
          "Para contactar al vendedor, abre el enlace y toca el botón de WhatsApp";
        textarea.value = "Descubre más aquí:";

        textarea.style.height = "auto"; // Reset height to shrink if needed
        textarea.style.height = textarea.scrollHeight + "px"; // Expand based on content

        console.log(this.#data);

        let price = "$preguntar";
        let onDiscountText = "";

        if (this.#data.listing?.listingPriceMarkedAs !== "preguntar") {
          price = GENRALHELPERS._convertToPrice(
            this.#data.listing.listingPrice,
            this.#data.listing.listingCoin
          );

          console.log(
            this.#data.listing?.onDiscount?.finalPrice,
            this.#data.listing.listingPrice
          );
          if (
            this.#data.listing?.onDiscount?.finalPrice !==
            Number(this.#data.listing.listingPrice)
          ) {
            price = GENRALHELPERS._convertToPrice(
              this.#data.listing.onDiscount?.finalPrice,
              this.#data.listing.listingCoin
            );
            onDiscountText = "En descuento ahora";
          }
        }

        const setInLinkText = () => {
          let title = "";
          let description = "";

          title = price + " • " + this.#data.listing.listingName;
          description =
            this.#data.listing.listingCondition +
            " | " +
            onDiscountText +
            " | " +
            this.#data.listing.listingDescription;

          ShareWindowInLinkTitle.textContent = title;
          ShareWindowInLinkDescription.textContent = GENRALHELPERS._shortenText(
            description,
            25
          );
        };
        setInLinkText();

        console.log('218', useImg)

        const imgUrl = this.#data.listing.listingImgsIds[useImg];

        console.log('219', this.#data.listing.listingImgsIds)
        console.log('219', imgUrl)
        // generateHtml._prepareListing();
        const html = generateHtml._prepareImageForListing(imgUrl.res_500 ?? imgUrl);

        this._handleSelectCustomImgForSharing(
          this.#data.listing.listingImgsIds
        );

        ShareWindowInsertShareImgCon.insertAdjacentHTML("beforeend", html);
      } else if (this.#what === "business") {
        insertAllImagesToSelectFromMainContainer.style.display = "none";
        ShareWindowItemLinkText.textContent = this.#data.businessUrl;
        ShareWindowItemInstructionsText.textContent =
          "Para contactar este negocio, abre el enlace.";
        textarea.value = "Abre este negocio aquí:";

        textarea.style.height = "auto"; // Reset height to shrink if needed
        textarea.style.height = textarea.scrollHeight + "px"; // Expand based on content

        console.log("Should be sharing business now");


        console.log(this.#data);
        this.#imgLocalUrlForSharing =
          this.#data?.business?.images?.profile?.[0]?.res_500 ||
          this.#data?.business?.images?.profile?.[0]?.res_original ||
          this.#data?.business?.profileImg ||
          '';

        console.log(this.#imgLocalUrlForSharing);
        const html = generateHtml._prepareImageForBusiness(
          this.#imgLocalUrlForSharing
        );

        ShareWindowInsertShareImgCon.insertAdjacentHTML("beforeend", html);

        console.log(this.#data);
        const setInLinkText = () => {
          let title = "";
          let description = "";

          title = this.#data.business.name;

          description =
            this.#data.business.shortDescription +
            " | " +
            this.#data.business.about;

          ShareWindowInLinkTitle.textContent = title;
          ShareWindowInLinkDescription.textContent = GENRALHELPERS._shortenText(
            description,
            25
          );
        };
        setInLinkText();
      } else if (this.#what === "business list") {
        insertAllImagesToSelectFromMainContainer.style.display = "none";
        ShareWindowItemLinkText.textContent = this.#data.businessUrl;
        ShareWindowItemInstructionsText.textContent =
          "Para ver esta lista, abre el enlace.";
        textarea.value = "Ver lista:";

        textarea.style.height = "auto"; // Reset height to shrink if needed
        textarea.style.height = textarea.scrollHeight + "px"; // Expand based on content

        console.log("Should be sharing business list now", this.#data);
        this.#imgLocalUrlForSharing = this.#data.business.profileImg;
        const html = generateHtml._prepareImageForBusiness(
          this.#data.business.categories
            ?.find(cat => cat.machine === listName)
            ?.image
            ?.res_500
          ?? this.#data.business.profileImg

        );

        ShareWindowInsertShareImgCon.insertAdjacentHTML("beforeend", html);


        function pluralizeEs(word) {
          if (!word) return word;

          const STOP_WORDS = new Set([
            'de', 'del', 'con', 'a', 'al', 'en', 'por', 'para', 'sin', 'y', 'o', 'rtk'
          ]);

          const capitalize = str =>
            str.charAt(0).toUpperCase() + str.slice(1);

          // handle hyphenated words (pluralize each meaningful part)
          if (word.includes('-')) {
            return word
              .split('-')
              .map(part => {
                const lower = part.toLowerCase();

                // stop words stay lowercase
                if (STOP_WORDS.has(lower)) return lower;

                const plural = pluralizeEs(part);
                return capitalize(plural);
              })
              .join(' ');
          }

          let result;

          // already plural-ish
          if (word.endsWith('s') || word.endsWith('es')) {
            result = word;
          }
          // z → ces
          else if (word.endsWith('z')) {
            result = word.slice(0, -1) + 'ces';
          }
          // vowel → s
          else if (/[aeiouáéíóú]$/i.test(word)) {
            result = word + 's';
          }
          // consonant → es
          else {
            result = word + 'es';
          }

          // capitalize single words (unless stop word)
          return STOP_WORDS.has(result.toLowerCase())
            ? result.toLowerCase()
            : capitalize(result);
        }






        console.log(this.#data);
        const setInLinkText = () => {
          let title = "";
          let description = "";
          let tag = this.#data.business.categories
            ?.find(cat => cat.machine === listName)
            ?.name
            ?? pluralizeEs(listName)

          title = this.#data.business.name + " | " + tag;

          description =
            `Descubre nuestra lista de '${tag}'`

          ShareWindowInLinkTitle.textContent = title;
          ShareWindowInLinkDescription.textContent = description
        };
        setInLinkText();
      } else {
        console.error("This image is not for listing sharing");
        insertAllImagesToSelectFromMainContainer.style.display = "none";
      }
    } catch (error) {
      alert(`Here: ${error}`);
    } finally {
      spinner._hideSpinner();
      this._shareImageFromContainer();
    }
  }

  _copyToClipboard(text) {
    spinner._displaySpinner("Copiando texto");
    if (navigator.clipboard) {
      navigator.clipboard
        .writeText(text)
        .then(() => {
          console.log("Text copied to clipboard:", text);
          spinner._hideSpinner();
        })
        .catch((err) => {
          spinner._hideSpinner();
          console.error("Failed to copy text:", err);
        });
    } else {
      // Fallback for older browsers
      const textarea = document.createElement("textarea");
      textarea.value = text;
      document.body.appendChild(textarea);
      textarea.select();
      try {
        spinner._hideSpinner();
        document.execCommand("copy");
        console.log("Text copied to clipboard (fallback):", text);
      } catch (err) {
        spinner._hideSpinner();
        console.error("Fallback: Failed to copy text:", err);
      }
      document.body.removeChild(textarea);
    }
  }

  _getCombinedText() {
    // Get the text from the textarea
    const textArea = document.getElementById("editableTextInShareNowInput");
    const textAreaValue = textArea.value.trim(); // Trim removes extra spaces

    // Get the text from the span with class 'link'
    const linkSpan = document.querySelector(".link");
    const linkText = linkSpan ? linkSpan.textContent.trim() : "";
    const instructionsSpan = document.querySelector(".instructions");
    const instructionsText = instructionsSpan
      ? instructionsSpan.textContent.trim()
      : "";

    // Combine both texts
    const combinedText = `${textAreaValue} ${linkText} \n \n *${instructionsText}*`;

    console.log(combinedText);
    return combinedText;
  }

  // async _shareImageFromContainer() {
  //   const ShareWindowCon3 = document.getElementById("ShareWindowCon3");

  //   // Start showing the spinner immediately
  //   spinner._displaySpinner("Preparando para compartir");

  //   try {
  //     // Check if sharing is supported
  //     if (navigator.canShare) {
  //       await navigator.share({
  //         title: this._getCombinedText(),
  //       });

  //       console.log("Image shared successfully!");

  //       let dataSendToShare = {
  //         listingId: this.#data.listing.listingId,
  //       };

  //       if (this.#isFromBusiness) {
  //         dataSendToShare = {
  //           listingId: this.#data.listing.listingId,
  //           businessId: this.#data.listing.businessId,
  //         };
  //       }

  //       firebase._updateSharesOnListings(dataSendToShare);
  //     } else {
  //       alert(
  //         "Error. La opción de compartir no está disponible en este dispositivo. Favor de copiar el enlace y pegarlo donde lo quiere compartir."
  //       );
  //     }
  //   } catch (err) {
  //     console.error("Error while sharing the image:", err);

  //     if (err.message && err.message.includes("gesture")) {
  //       alert(
  //         "Porfavor use el botón verde 'Compartir de nuevo' para compartir este articulo."
  //       );
  //       if (ShareWindowCon3) {
  //         GENRALHELPERS._animateCTA("ShareWindowButtonShareAgain");
  //       }
  //     } else if (
  //       err.message &&
  //       err.message.includes("possibly because the user denied permission")
  //     ) {
  //       alert(
  //         "Porfavor use el botón verde 'Compartir de nuevo' para compartir este articulo."
  //       );
  //     } else {
  //       // alert("Este articulo no fué compartido");
  //     }

  //   }finally {
  //     spinner._hideSpinner();
  //   }
  // }




  async _shareImageFromContainer() {
    console.log('here');
    const ShareWindowCon3 = document.getElementById("ShareWindowCon3");

    spinner._displaySpinner("Preparando para compartir");

    try {

      const shareData = {
        title: 'Es Mercado MAI',
        text: this._getCombinedText(),
        // url: 'Es Mercado MAI' // or your listing URL
      };

      // ✅ 1. Native (Android / iOS via Capacitor)
      if (window.Capacitor?.isNativePlatform?.()) {
        await Share.share({
          title: shareData.title,
          text: shareData.text,
          // url: shareData.url,
          dialogTitle: 'Compartir'
        });

        console.log("Shared via native share");

        // ✅ 2. Web Share API (mobile browser)
      } else if (navigator.share) {
        await navigator.share(shareData);

        console.log("Shared via web share");

        // ❌ 3. Fallback
      } else {
        alert("No se puede compartir automáticamente. Copia el enlace manualmente.");
        return;
      }

      // ✅ Track share (same as your logic)
      let dataSendToShare = {
        listingId: this.#data.listing.listingId,
      };

      if (this.#isFromBusiness) {
        dataSendToShare.businessId = this.#data.listing.businessId;
      }

      firebase._updateSharesOnListings(dataSendToShare);

    } catch (err) {
      console.error("Error while sharing:", err);

      // Same UX handling you already had
      if (err.message?.includes("gesture")) {
        alert("Por favor usa el botón 'Compartir de nuevo'.");
        if (ShareWindowCon3) {
          GENRALHELPERS._animateCTA("ShareWindowButtonShareAgain");
        }
      } else if (err.message?.includes("denied")) {
        alert("Permiso denegado. Intenta nuevamente.");
      }

    } finally {
      spinner._hideSpinner();
    }
  }
}
export default new ShareNow();
